import { createSlice } from '@reduxjs/toolkit'
import { initialFields } from './specializationFormFields'

const initialState = {
    fields: initialFields,
}

const specializationFormSlice = createSlice({
    name: 'specializationForm',
    initialState,
    reducers: {
        setFields(state, action) {
            state.fields = action.payload
        },
        resetFields(state) {
            state.fields = initialFields
        }
    },
})

export const { setFields, resetFields } = specializationFormSlice.actions
export default specializationFormSlice.reducer
